const Heading = {
  baseStyle: {
    color: 'gray.700',
    textTransform: 'uppercase',
  },
};

export default Heading;
